import { useEffect, useState } from 'react';
import { staticOnly } from '../three/EcosystemFrame';

// Command view on/off, remembered per surface (localStorage nv.commandView.<key>).
// Default ON. Surfaces that cannot run the scene (reduced motion, no WebGL,
// small screens) report `supported: false` and the caller renders classic
// with the toggle hidden.
export default function useCommandToggle(key, defaultOn = true) {
  const storageKey = `nv.commandView.${key}`;
  const [on, setOn] = useState(() => {
    try { const v = localStorage.getItem(storageKey); return v == null ? defaultOn : v === '1'; } catch { return defaultOn; }
  });
  const [supported, setSupported] = useState(false);
  useEffect(() => { setSupported(!staticOnly()); }, []);
  const set = (v) => {
    setOn(v);
    try { localStorage.setItem(storageKey, v ? '1' : '0'); } catch { /* ignore */ }
  };
  return { on: on && supported, supported, set, raw: on };
}

export function CommandToggle({ on, onChange, labels = ['Command view', 'Classic'] }) {
  return (
    <span className="cmd-toggle" role="group" aria-label="View mode">
      <button type="button" className={`cmd-toggle-btn ${on ? 'is-active' : ''}`} onClick={() => onChange(true)} aria-pressed={on}>{labels[0]}</button>
      <button type="button" className={`cmd-toggle-btn ${!on ? 'is-active' : ''}`} onClick={() => onChange(false)} aria-pressed={!on}>{labels[1]}</button>
    </span>
  );
}
